import { apiSlice } from '../../app/api/apiSlice'
import { generateFormatedURL } from "../urlFormatter";

const dashboardApiSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        getLatestAlert: builder.query<any, void>({
            query: () => "/Dashboard/latestAlert"//.concat(generateFormatedURL(args)),
        }),

        getCompletedSchedule: builder.query<any, void>({
            query: () => "/Dashboard/todayCompleted",
        }),

        getTodayAlertCount: builder.query<any, void>({
            query: () => "/Dashboard/alert/today",
        }),

        getThisWeekAlertCount: builder.query<any, void>({
            query: () => "/Dashboard/alert/thisWeek",
        }),

        getThisMonthAlertCount: builder.query<any, void>({
            query: () => "/Dashboard/alert/thisMonth",
        }),

        getWorkerOverView: builder.query<any, void>({
            query: () => "Dashboard/worker/overView",
        }),
    })
});

export const {
    useGetLatestAlertQuery,
    useGetCompletedScheduleQuery,
    useLazyGetTodayAlertCountQuery,
    useLazyGetThisWeekAlertCountQuery,
    useLazyGetThisMonthAlertCountQuery,
    useLazyGetWorkerOverViewQuery,
} = dashboardApiSlice;
